import { render, staticRenderFns } from "./NonAlfaBtn.vue?vue&type=template&id=8e71a108&"
import script from "./NonAlfaBtn.vue?vue&type=script&lang=js&"
export * from "./NonAlfaBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports